import { IdCardApplication, IdCardApplicationType } from '../types/id-card.types';

export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];

export const PAYMENT_METHODS = ['Cash', 'Bank Transfer', 'bKash', 'Nagad'];

/** Existing UILM labels for the two application types. */
export const ID_CARD_APPLICATION_TYPES: { value: IdCardApplicationType; labelKey: string }[] = [
  { value: 'NewJoiner', labelKey: 'NEW_JOINER' },
  { value: 'Reissue', labelKey: 'REISSUE' },
];

export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/** A re-issued card is charged for, so only a Reissue collects payment details and a receipt. */
export const requiresPayment = (applicationType: IdCardApplicationType) =>
  applicationType === 'Reissue';

/**
 * Returns the translation key of why `file` cannot be attached, or null when it is acceptable:
 * images only, at most 5 MB (the legacy limits for both the photo and the receipt).
 */
export const validateImageFile = (file: { type: string; size: number }) => {
  if (!file.type.startsWith('image/')) return 'ONLY_IMAGE_FILES_ARE_ALLOWED';
  if (file.size > MAX_IMAGE_BYTES) return 'IMAGE_SIZE_MUST_BE_LESS_THAN_5_MB';
  return null;
};

/** Legacy UI: an applicant may edit an application only while it is still pending. */
export const canEditIdCard = (application: IdCardApplication) => application.Status === 'Pending';

/** `Delivered` is the end of the pipeline: nothing may move an application out of it. */
export const isIdCardStatusLocked = (application: IdCardApplication) =>
  application.Status === 'Delivered';
